import { useState } from 'react';

export const TextInput = ({ type, id, name, labelName }) => {
    const [inputValue, setInputValue] = useState('');

    return (
        <>
            <label htmlFor={id}>{labelName}</label>
            <input
                value={inputValue}
                name={name}
                type={type}
                id={id}
                onChange={(evt) => setInputValue(evt.target.value)}
                className="login-input"
            />
        </>
    );
};
